'use client';
import { useState, useEffect } from 'react';

function makeGetKey(e) {
    return `${e}/get`;
}
function makeHasKey(e) {
    return `${e}/has`;
}
function browserHistoryStateHas(e, t) {
    return (null == e ? void 0 : e[makeHasKey(t)]) === true;
}
function browserHistoryStateGet(e, t) {
    return null == e ? void 0 : e[makeGetKey(t)];
}
function browserHistoryStateGetOrDefault(e, t, r) {
    return browserHistoryStateHas(e, t) ? browserHistoryStateGet(e, t) : r;
}
function useBrowserHistoryState(r, a, o) {
    let [s, i] = useState(()=>'undefined' != typeof window ? browserHistoryStateGetOrDefault(window.history.state, r, a) : a), n = (null == o ? void 0 : o.replace) === true;
    return useEffect(()=>{
        let e = browserHistoryStateGetOrDefault(window.history.state, r, a);
        !s && e && n ? window.history.replaceState({
            [makeGetKey(r)]: false,
            [makeHasKey(r)]: true
        }, '') : JSON.stringify(s) !== JSON.stringify(e) && (window.history.pushState({
            [makeGetKey(r)]: s,
            [makeHasKey(r)]: true
        }, ''), n && window.history.replaceState({
            [makeGetKey(r)]: false,
            [makeHasKey(r)]: true
        }, ''));
    }, [
        s,
        r,
        a,
        n
    ]), useEffect(()=>{
        let popStateHandler = (e)=>{
            let t = browserHistoryStateGetOrDefault(e.state, r, a);
            JSON.stringify(t) !== JSON.stringify(s) && i(t);
        };
        return window.addEventListener('popstate', popStateHandler), ()=>window.removeEventListener('popstate', popStateHandler);
    }, [
        s,
        r,
        a
    ]), [
        s,
        i
    ];
}

export { useBrowserHistoryState };
